import React, { useEffect, useState } from "react";
import "./Counter.css";
import { defaultHomeSettings, normalizeHomeSettings } from "../utils/homeContent";

function Counter({ target }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 1000;
    const increment = Number(target || 0) / (duration / 20);

    const timer = setInterval(() => {
      start += increment;
      if (start >= Number(target || 0)) {
        setCount(Number(target || 0));
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 20);

    return () => clearInterval(timer);
  }, [target]);

  return <h1>{count}+</h1>;
}

function CounterSection({ settings }) {
  const homeSettings = normalizeHomeSettings(settings || defaultHomeSettings);

  return (
    <div className="counter-section">
      <h2 className="counter-title">{homeSettings.counters_section_title}</h2>

      <div className="counter-grid">
        {homeSettings.counters.map((item) => (
          <div className="counter-box" key={item.label}>
            <Counter target={item.value} />
            <p>{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CounterSection;
